import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class KMDGameAssets {

    public static BITMAP_FONT_WIN_COUNT_UP: string = "multi";
    public static BITMAP_FONT_MULTIPLIER: string = "top_multiplier_leather_font";
    public static BITMAP_FONT_SYM_COUNT: string = "multi";
    public static BITMAP_FONT_WIN_CAP: string = "KMD_font";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset(KMDGameAssets.BITMAP_FONT_MULTIPLIER, "fonts/bitmapfonts/top_multiplier_leather_font.fnt"),
                    new BitmapFontAsset(KMDGameAssets.BITMAP_FONT_SYM_COUNT, "fonts/bitmapfonts/multi.fnt"),
                    new BitmapFontAsset(KMDGameAssets.BITMAP_FONT_WIN_CAP, "fonts/bitmapfonts/KMD_font.fnt")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json"),
                    new TextureAsset("main9", "sheets/main/main9.json"),
                    new TextureAsset("main10", "sheets/main/main10.json"),
                    new TextureAsset("main11", "sheets/main/main11.json"),
                    new TextureAsset("main12", "sheets/main/main12.json"),
                    new TextureAsset("main13", "sheets/main/main13.json"),
                    new TextureAsset("main14", "sheets/main/main14.json")
                ]
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json")
                ]
            },
            {
                name: "symbols",
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json"),
                    new TextureAsset("symbols2", "sheets/symbols/symbols2.json"),
                    new TextureAsset("symbols3", "sheets/symbols/symbols3.json"),
                    new TextureAsset("symbols4", "sheets/symbols/symbols4.json")
                ],
                autoLoad: [AssetQualityLevel.HIGH]
            },
            {
                name: "symbolsFrame",
                assets: [
                    new TextureAsset("symbolsFrame0", "sheets/symbolsFrame/symbolsFrame0.json")
                ],
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("xWaysReveal", "spine/Xways_reveal.json"),
                    new SpineAsset("mgIntroBeefy", "spine/beefy_dick_intro_small_size.json"),
                    new SpineAsset("S", "spine/S1.json"),
                    new SpineAsset("S2", "spine/S2.json"),
                    new SpineAsset("X_WAYS", "spine/Xways.json"),
                    new SpineAsset("X_NUDGE_WILD", "spine/xnudge_expand.json"),
                    new SpineAsset("XH", "spine/xhole.json"),
                    new SpineAsset("XHBlur", "spine/xhole_blur.json"),
                    new SpineAsset("mgBgAnimation", "spine/MG_BG_Animation.json"),
                    new SpineAsset("fsBgAnimation", "spine/FS_BG_Animation.json"),
                    new SpineAsset("sfsBgAnimation", "spine/SFS_BG_Animation.json"),
                    new SpineAsset("logo", "spine/Logo.json"),
                    new SpineAsset("fsIntro", "spine/fs_intro.json"),
                    new SpineAsset("cfsIntro", "spine/cool_intro.json"),
                    new SpineAsset("sfsIntro", "spine/sfs_intro.json"),
                    new SpineAsset("fsOutro", "spine/fs_outro.json"),
                    new SpineAsset("cfsOutro", "spine/cool_outro.json"),
                    new SpineAsset("sfsOutro", "spine/sfs_outro.json"),
                    new SpineAsset("symHighlight", "spine/syms_high_light.json"),
                    new SpineAsset("symExplode", "spine/symbols_win.json"),
                    new SpineAsset("bigWin", "spine/sfs_BW.json"),
                    new SpineAsset("bigWinLevel6", "spine/beefy_win.json"),
                    new SpineAsset("ways", "spine/ways.json"),
                    new SpineAsset("suckOverlay", "spine/new_suck_effect.json"),
                    new SpineAsset("suckClose", "spine/xhole_close_glow.json"),
                    new SpineAsset("xHoleBlast", "spine/xhole_blast.json"),
                    new SpineAsset("xBet", "spine/xbet_button.json"),
                    new SpineAsset("mgReelFrame", "spine/MG_reel_Animation.json"),
                    new SpineAsset("fsReelFrame", "spine/FS_reel_Animation.json"),
                    new SpineAsset("sfsReelFrame", "spine/SFS_reel_Animation.json"),
                    new SpineAsset("barbieCar", "spine/Car.json"),
                    new SpineAsset("beefyCar", "spine/Beefy_With_Car.json"),
                    new SpineAsset("kenCar", "spine/fordMustangCar.json"),
                    new SpineAsset("xBetReelFrame", "spine/xbet_dildo_frame.json"),
                    new SpineAsset("xBetReelFrameMaxBet", "spine/xbet_frame.json"),
                    new SpineAsset("winCapBg", "spine/win_cap_v1_bg.json"),
                    new SpineAsset("winCapCountUp", "spine/countup_animation.json"),
                    new SpineAsset("winCap", "spine/win_cap_v1.json"),
                    new SpineAsset("winCapOldFilm", "spine/old_film_effect.json"),
                    new SpineAsset("handChain", "spine/butt_chain.json"),
                    new SpineAsset("symIgnite", "spine/sp_fire_frame.json"),
                    new SpineAsset("flicker", "spine/spM1M2Transform.json"),
                    new SpineAsset("spM1M2Heart", "spine/heart_effect.json"),
                    new SpineAsset("lightSweep", "spine/light_sweep.json"),
                    new SpineAsset("locks", "spine/locked_frame.json"),
                    new SpineAsset("fsAnticipation", "spine/fs_anticipation.json"),
                    new SpineAsset("cfsAnticipation", "spine/cfs_anticipation.json"),
                    new SpineAsset("sfsAnticipation", "spine/sfs_anticipation.json"),
                    new SpineAsset("fireHouse", "spine/fire_house.json"),
                    new SpineAsset("limitCapButton", "spine/wincap_handle.json")
                ]
            }
        ]
    };
}
